<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  modelValue?: boolean
  open?: boolean
  title: string
  subtitle?: string
  size?: string
  direction?: 'rtl' | 'ltr' | 'ttb' | 'btt'
  beforeClose?: (done: () => void) => void
}>(), {
  modelValue: false,
  open: false,
  size: '620px',
  direction: 'rtl',
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  close: []
}>()

const visible = computed(() => props.open || props.modelValue)

function update(value: boolean): void {
  emit('update:modelValue', value)
  if (!value) emit('close')
}
</script>

<template>
  <el-drawer
    class="ui-drawer"
    :model-value="visible"
    :title="title"
    :size="size"
    :direction="direction"
    :before-close="beforeClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body
    @update:model-value="update"
  >
    <template #header>
      <div class="drawer-head">
        <div class="drawer-head__text">
          <div class="drawer-title">{{ title }}</div>
          <div v-if="subtitle" class="drawer-sub">{{ subtitle }}</div>
        </div>
        <slot name="head-extra" />
      </div>
    </template>
    <slot />
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </el-drawer>
</template>

<style scoped>
:deep(.el-drawer__footer) {
  padding: 0;
}
</style>
